import React, { useContext } from 'react';
import { IClientContact, ISupplierContact } from '@bb/contacts';
import { NoContactsSVG } from '@brokerbay/elements-web';

import { Button, Icon } from 'components';
import {
  ContactDrawerContext,
  ContactDrawerMode,
  ContactDrawerType,
} from 'contexts';
import { featureEnabled } from 'utils';
import { EmptyContainer, EmptySection } from '../components';
import { StyledContactItemContainer } from './styled';
import ContactItem from './ContactItem';

type ContactCardContentProps = {
  contacts: (IClientContact | ISupplierContact)[];
};

const ContactCardContent: React.FC<ContactCardContentProps> = ({
  contacts,
}) => {
  const { openContactDrawer } = useContext(ContactDrawerContext);

  if (!contacts.length) {
    if (featureEnabled('showingsMadeEasyFeature')) {
      return (
        <EmptySection
          dataCy="no-contacts"
          Image={<NoContactsSVG width={200} height={120} />}
          mainText="No contacts yet"
          secondaryText="Add contacts to view them here."
        />
      );
    }

    return (
      <EmptyContainer>
        <Icon type="antdHomeFilled" width={34} color="gray6" offset={[0, 2]} />
        <span>No contacts yet</span>
        <Button
          onClick={() => {
            openContactDrawer(ContactDrawerMode.Add, ContactDrawerType.Contact);
          }}
          data-cy="add-contact-button"
        >
          Add Contact
        </Button>
      </EmptyContainer>
    );
  }

  return (
    <>
      {contacts.map((contact, index) => (
        <StyledContactItemContainer
          key={index}
          onClick={() => {
            openContactDrawer(
              ContactDrawerMode.Profile,
              ContactDrawerType.Contact,
              contact.id,
            );
          }}
          data-cy="contact-view-details"
        >
          <ContactItem contact={contact} />
        </StyledContactItemContainer>
      ))}
    </>
  );
};

export default ContactCardContent;
